export default __webpack_public_path__ + "static/media/fae.75c30c8e.png";